
export default {
  data() {
    return {
      loading: false, // 接口请求中
      state: 1,
      LanguageCode: this.$store.state.LanguageCode, // 当前页面语言
      emailState: false, // 邮箱状态
      smsState: false, // 验证码状态
      countDown: 0, // 倒计时秒数
      iscountdown: false, // 是否展示倒计时
      passwordState: false, // 密码状态
      oncepasswordState: false, // 再次密码状态
      seyes: false, // 密码眼睛状态
      twoseyes: false, // 再次密码眼睛状态
      forgetInfo: {
        email: '',
        emailError: '',
        sms: '',
        smsError: '',
        requestId: '', // 获取验证码返回
        password: '',
        oncepassword: '',
        passwordError: '' // 密码 错误
      }
    }
  },
  computed: {
    title() {
      // 标题
      switch (this.state) {
        case 1:
          return this.$v('忘记密码')
        case 2:
          return this.$v('重置密码')
        default:
          return this.$v('无头')
      }
    },
    btnState() {
      if (this.state == 1 && this.forgetInfo.email && this.forgetInfo.sms) {
        return true
      } else if (this.state == 2 && this.forgetInfo.password.length > 5 && this.forgetInfo.oncepassword.length > 5) {
        return true
      } else {
        return false
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    async login() {
      if (this.btnState) {
        if (this.state == 1) {
          const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/ // 邮箱校验
          if (reg.test(this.forgetInfo.email)) {
            this.forgetInfo.emailError = ''
            if (this.loading) return
            this.loading = true
            const newusercenteremailisexistv2 = await this.$api.common
              .CV3(
                {
                  // 校验邮箱是否注册
                  email: this.forgetInfo.email,
                  languageCode: this.LanguageCode
                },
                {
                  Routes: 'usercenter$newusercenteremailisexistv2'
                }
              )
              .catch(() => {
                console.log('newusercenteremailisexistv2')
              })
            if (newusercenteremailisexistv2 && newusercenteremailisexistv2.usercenter && newusercenteremailisexistv2.usercenter.newusercenteremailisexistv2) {
              if (!newusercenteremailisexistv2.usercenter.newusercenteremailisexistv2.success) {
                this.loading = false
                this.forgetInfo.emailError = newusercenteremailisexistv2.usercenter.newusercenteremailisexistv2.extra // 数据错误
                return
              }
              if (!newusercenteremailisexistv2.usercenter.newusercenteremailisexistv2.data) {
                this.loading = false
                this.forgetInfo.emailError = this.$v('邮箱不存在')
                return
              } // 数据错误
              this.forgetInfo.emailError = ''
              this.checkemail()
            }
          } else {
            this.forgetInfo.emailError = '邮箱格式不正确'
          }
        } else if (this.state == 2) {
          this.resetsud()
        }
      }
    },
    async resetsud() {
      if (this.forgetInfo.password != this.forgetInfo.oncepassword) return (this.forgetInfo.passwordError = this.$v('两次密码不一致'))
      else if (this.forgetInfo.password.length < 6 || this.forgetInfo.password.length > 20) return (this.forgetInfo.passwordError = this.$v('密码为6-20位，不能包含汉字或空格'))
      this.forgetInfo.passwordError = ''
      const newusercenteforrgetuserpassv2 = await this.$api.common
        .CV3(
          {
            npwd: this.forgetInfo.password,
            requestId: this.forgetInfo.requestId,
            languageCode: this.LanguageCode,
            email: this.forgetInfo.email
          },
          {
            Routes: 'usercenter$newusercenteforrgetuserpassv2'
          }
        )
        .catch(() => {
          console.log('newusercenteforrgetuserpassv2')
        })
      console.log('newusercenteforrgetuserpassv2: ', newusercenteforrgetuserpassv2)
      if (newusercenteforrgetuserpassv2 && newusercenteforrgetuserpassv2.usercenter && newusercenteforrgetuserpassv2.usercenter.newusercenteforrgetuserpassv2) {
        if (!newusercenteforrgetuserpassv2.usercenter.newusercenteforrgetuserpassv2.success)
          return (this.forgetInfo.passwordError = newusercenteforrgetuserpassv2.usercenter.newusercenteforrgetuserpassv2.extra) // 数据错误
        this.forgetInfo.passwordError = ''
        this.$message({
          message: this.$v('重置成功'),
          type: 'success'
        })
        this.$emit('back', 1)
      }
    },
    back() {
      if (this.state == 1) {
        this.$emit('back', 1)
        this.forgetInfo.email = this.forgetInfo.emailError = this.forgetInfo.sms = this.forgetInfo.smsError = ''
        this.emailState = this.smsState = false
      } else if (this.state == 2) {
        this.state = 1
        this.forgetInfo.password = this.forgetInfo.oncepassword = this.forgetInfo.passwordError = ''
        this.seyes = this.twoseyes = this.passwordState = this.oncepasswordState = false
      }
    },
    async sendcode() {
      // 手机验证通过出现极验
      const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/ // 邮箱校验
      const { email = '' } = this.forgetInfo // 手机号为空true/false
      if (!email) return false
      if (reg.test(this.forgetInfo.email)) {
        this.forgetInfo.emailError = ''
        const newusercenteremailisexistv2 = await this.$api.common
          .CV3(
            {
              // 校验邮箱是否注册
              email: this.forgetInfo.email,
              languageCode: this.LanguageCode
            },
            {
              Routes: 'usercenter$newusercenteremailisexistv2'
            }
          )
          .catch(() => {
            console.log('newusercenteremailisexistv2')
          })
        console.log('newusercenteremailisexistv2: ', newusercenteremailisexistv2)
        if (newusercenteremailisexistv2 && newusercenteremailisexistv2.usercenter && newusercenteremailisexistv2.usercenter.newusercenteremailisexistv2) {
          if (!newusercenteremailisexistv2.usercenter.newusercenteremailisexistv2.success)
            return (this.forgetInfo.emailError = newusercenteremailisexistv2.usercenter.newusercenteremailisexistv2.extra) // 数据错误
          if (!newusercenteremailisexistv2.usercenter.newusercenteremailisexistv2.data) return (this.forgetInfo.emailError = this.$v('邮箱不存在')) // 数据错误
          this.forgetInfo.emailError = ''
          const newusercentersendemailv2 = await this.$api.common
            .CV3(
              {
                // 发送验证码
                email: this.forgetInfo.email,
                emailType: 3,
                languageCode: this.LanguageCode,
                applicationType: 7,
                version: 124
              },
              {
                Routes: 'usercenter$newusercentersendemailv2'
              }
            )
            .catch(() => {
              console.log('newusercenterphoneisregisterv2')
            })
          if (newusercentersendemailv2 && newusercentersendemailv2.usercenter && newusercentersendemailv2.usercenter.newusercentersendemailv2) {
            if (!newusercentersendemailv2.usercenter.newusercentersendemailv2.success) return (this.forgetInfo.emailError = newusercentersendemailv2.usercenter.newusercentersendemailv2.extra) // 数据错误
            this.forgetInfo.emailError = this.forgetInfo.smsError = ''
            this.countDown = 60
            this.iscountdown = true // 是否开始倒计时
            this.startCount() // 开始倒计时
          }
        }
      } else {
        this.forgetInfo.emailError = this.$v('邮箱格式不正确')
      }
    },
    async checkemail() {
      // 校验邮箱验证码
      const newusercentervalidateemailcodev2 = await this.$api.common
        .CV3(
          {
            Email: this.forgetInfo.email,
            LanguageCode: this.LanguageCode,
            Code: this.forgetInfo.sms,
            ApplicationType: 7
          },
          {
            Routes: 'usercenter$newusercentervalidateemailcodev2'
          }
        )
        .catch(() => {
          console.log('newusercentervalidateemailcodev2')
        })
      console.log('newusercentervalidateemailcodev2: ', newusercentervalidateemailcodev2)
      if (newusercentervalidateemailcodev2 && newusercentervalidateemailcodev2.usercenter && newusercentervalidateemailcodev2.usercenter.newusercentervalidateemailcodev2) {
        this.loading = false
        if (!newusercentervalidateemailcodev2.usercenter.newusercentervalidateemailcodev2.success)
          return (this.forgetInfo.smsError = newusercentervalidateemailcodev2.usercenter.newusercentervalidateemailcodev2.extra) // 数据错误
        this.forgetInfo.smsError = ''
        this.forgetInfo.requestId = newusercentervalidateemailcodev2.usercenter.newusercentervalidateemailcodev2.data.requestId
        this.state = 2
      }
      if (this.loading) {
        // 处理意外情况 接口报错
        setTimeout(() => {
          this.loading = false
        }, 5000)
      }
    },
    startCount() {
      this.countDown--
      if (this.countDown < 1) {
        // 倒计时结束
        clearTimeout(this.vTimer)
        this.countimes++
        this.iscountdown = false // 倒计时关闭
        return true
      }
      this.vTimer = setTimeout(this.startCount, 1000)
    }
  }
}
